import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n/LanguageContext';

/**
 * Small explanatory callout — "Why Telegram and not WhatsApp?"
 * Compact card on the cream background. Sits between Tools and Community,
 * answering a question users naturally ask after seeing chat mockups.
 */
export default function WhyTelegram() {
  const { t } = useLanguage();
  if (!t.wt_h) return null;

  return (
    <section
      id="why-telegram"
      className="bg-ev-cream pt-16 md:pt-20 pb-16 md:pb-20 px-6 md:px-10"
      data-testid="why-telegram-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-[760px] mx-auto bg-white border border-ev-gray-border rounded-[1.75rem] p-8 md:p-12 relative">
        {/* Diagonal corner accent */}
        <span
          aria-hidden="true"
          className="absolute -top-2 -right-2 w-12 h-12 rounded-full bg-ev-lime/60 blur-2xl"
        />

        <p className="font-body text-[10px] uppercase tracking-[0.4em] text-ev-ink/60 mb-5">
          {t.wt_label}
        </p>
        <h2
          className="font-display font-light text-ev-ink lowercase mb-6 leading-[1.05]"
          style={{ fontSize: 'clamp(1.6rem, 3.4vw, 2.5rem)', letterSpacing: '-0.025em' }}>
          {t.wt_h}
        </h2>

        <p className="font-body text-base md:text-[17px] text-ev-ink/80 leading-relaxed mb-4">
          {t.wt_body}
        </p>
        <p className="font-body text-base md:text-[17px] text-ev-ink leading-relaxed">
          {t.wt_body2}
        </p>

        {t.wt_footnote && (
          <p className="mt-7 pt-5 border-t border-ev-gray-border font-body text-[11px] uppercase tracking-[0.2em] text-ev-gray-light">
            {t.wt_footnote}
          </p>
        )}
      </motion.div>
    </section>
  );
}
